import { Button } from "primereact/button";
import { Card } from "primereact/card";
import React from "react";
import {
    appSectionCardStyle,
    renderSurfaceHeader,
} from "../../../../components/general/uiSurfaceStyles";

interface StepCarePlanIntroProps {
    onNext: () => void;
    onBack: () => void;
}

const CARE_PLAN_PARAGRAPHS = [
    "The portion of the assessment from this point on is considered to be the Negotiated Plan of Care based on the assessed needs noted in the first part of this document. The RN must assess the needs of the client and the care provider, client, to the extent possible, family members and nurse will define how care is delivered in the Negotiated Plan of Care.",
    "As the provider sees subtle changes in the clients care needs or finds different ways of doing things, the care provider may make notations on the care plan portion. Upon RN visits (typically every 60-90 days when delegation is due) the RN will review any notes regarding care methods or delivery of services and if needed will update the Assessment portion of this document.",
];

const StepCarePlanIntro: React.FC<StepCarePlanIntroProps> = ({ onNext, onBack }) => (
    <>
        <div className="flex justify-content-center gap-2 mb-3">
            <Button type="button" label="Prev" icon="pi pi-arrow-left" severity="secondary" outlined rounded onClick={onBack} />
            <Button type="button" label="Continue to Daily Living" icon="pi pi-arrow-right" iconPos="right" severity="warning" rounded onClick={onNext} />
        </div>

        <Card style={appSectionCardStyle} className="mb-3">
            {renderSurfaceHeader(
                "Care Plan / Activities of Daily Living",
                "The next sections are used to document the negotiated plan of care and ongoing service delivery details.",
                "pi pi-clipboard",
            )}
            <div className="p-3">
                {CARE_PLAN_PARAGRAPHS.map((paragraph, index) => (
                    <p
                        key={index}
                        style={{
                            margin: 0,
                            marginBottom: index === CARE_PLAN_PARAGRAPHS.length - 1 ? "1rem" : "0.9rem",
                            color: "#334155",
                            lineHeight: 1.8,
                            fontSize: "0.95rem",
                        }}
                    >
                        {paragraph}
                    </p>
                ))}

                <div
                    style={{
                        border: "1px solid #fed7aa",
                        background: "#fff7ed",
                        borderRadius: 12,
                        padding: "0.9rem 1rem",
                        color: "#9a3412",
                        fontSize: "0.9rem",
                        fontWeight: 600,
                    }}
                >
                    Care plan editing begins in the next section with Activities of Daily Living.
                </div>
            </div>
        </Card>
    </>
);

export default StepCarePlanIntro;
